import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import DOMPurify from 'dompurify';

import { os } from '@mirinae/js-utils/utils/userAgent';

import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { lessonsPalette, zIndex } from '@mirinae/lessons/modules/defines/styles';
import axios from 'axios';

const ImageCardElement = styled(Element)`
    display: flex;
    flex-direction: row;
    justify-content: center;;
    ${!os.isOthers && 'min-width: 100%;'}
`;

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: ${os.isOthers ? '100%' : 'calc(100% - 8px)'};
    width: ${props => (os.isOthers ? '100%' : `${props.geom.width}px`)};
    ${props => os.isOthers && `min-width: ${props.geom.width}px`};
    ${!os.isOthers && 'max-width: calc(100vw - 100px);'} // room for the side stpe-controls in mobile on narrow phones 
`;

const Card = styled.div`
    display: flex;
    width: 400px;
    height: 300px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.80);
`;

const EmbeddedSVG = styled.div`
`;

const EmbeddedImg = styled.img`
`;

const Graphic = ({ graphic, scale, svgEmbedRef }) => {
    const [cleanSVG, setCleanSVG] = useState('');
    const gotSVG = useRef(false);
    const scaleVal = scale ? scale.value : 1.0;

    useEffect(() => {
        if (graphic.mimeType === 'image/svg+xml' && svgEmbedRef.current && !gotSVG.current) {
            gotSVG.current = true;
            axios(graphic.url, {
                method: 'GET',
                withCredentials: false,
                headers: { 'Content-Type': 'image/svg+xml', },
            }).then(response => {
                // console.log(response);
                setCleanSVG(DOMPurify.sanitize(response.data, { ADD_TAGS: ['script'] }));
            })
            .catch(error => {
                console.log('error');
            });
        }
    }, []);

    // it appears the script contained in the retrieved SVG is not automatically running, pull it out here and run it by hand.
    useEffect(() => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cleanSVG, 'image/svg+xml');
        const scriptElement = doc.querySelector('script');

        if (scriptElement) {
            const script = document.createElement('script');
            script.innerHTML = scriptElement.textContent;
            document.body.appendChild(script);
            return () => {
                document.body.removeChild(script);
            };
        }
    }, [cleanSVG]);

    return (
        graphic.mimeType === 'image/svg+xml' ? (
            <EmbeddedSVG ref={svgEmbedRef} dangerouslySetInnerHTML={{__html: cleanSVG}} style={{ transform: `scale(${scaleVal})` }} />
        ) : (
            <EmbeddedImg src={graphic.url} style={{ transform: `scale(${scaleVal})` }} />
        )
    );
};

const ImageCard = ({ element, geomElement }) => {
    const [audioEl, setAudioEl] = useState(null);
    const [showPronunciation, setShowPronunciation] = useState(false);
    const svgEmbedRef = useRef(null);
    const geomEl = geomElement || element;

    return (
        <ImageCardElement className={`el-${element.componentName}`} element={element} geomElement={geomEl}>
            <CardWrapper geom={os.isOthers ? geomEl.geom : (geomEl.mobile && geomEl.mobile.geom)}>
                <Card className="image-card">
                    { element.fieldsByName.graphic.url &&
                        <Graphic graphic={element.fieldsByName.graphic} svgEmbedRef={svgEmbedRef} scale={element.fieldsByName.scale} /> }
                </Card>
            </CardWrapper>
        </ImageCardElement>
    );
};

export default ImageCard;
